import { ReminderEndpointService } from "@/views/reminder/shared/endpoint_services/reminder-endpoint-service"
import { SearchStuffModel } from "@/views/loyalty/models/search_stuff.model"

export class ReminderService {
    constructor () {
        this.reminderEndpointService = new ReminderEndpointService()
    }

    async createReminder (reminder) {
        reminder.receiver = reminder.receiver.join(";")
        return this.reminderEndpointService.create_reminder(reminder)
    }

    async deleteReminder (reminder_id) {
        return this.reminderEndpointService.delete_reminder(reminder_id)
    }

    async getAll (clientId, userId, page, limit, filter, search) {
        return this.reminderEndpointService.get_all(clientId, userId, page || 1, limit || -1, filter || [], search || SearchStuffModel)
    }

    async getById (reminder_id) {
        const reminder = await this.reminderEndpointService.get_by_id(reminder_id)
        if (reminder.receiver) { reminder.receiver = reminder.receiver.split(";") }
        return reminder
    }

    async updateReminder (reminder) {
        reminder.receiver = reminder.receiver.join(";")
        return this.reminderEndpointService.update_reminder(reminder)
    }
}
